module.exports = __webpack_public_path__ + "images/8baed9ec5f21940f76b9da2a76e77180-Las Vegas.jpg";